<div class="page-container container-fluid p-3">
  <div>
    <div style="background-color: whitesmoke">
      <div style="background-color: #54B4D3;color: white" class="p-2" fxLayout="row"
           fxLayoutAlign="space-between center">
        <h2 class="m-0">Active Contract Templates</h2>
      </div>
      <app-data-table class="data-table" #activeContractTable [stickyHeader]="true" [loading]="loading" [rows]="dataSource" [columnDefs]="displayedColumns" dateFormat="YYYY-MM-dd hh:mm"></app-data-table>
    </div>
    <div style="background-color: whitesmoke">
      <div style="background-color: #54B4D3;color: white" class="p-2" fxLayout="row"
           fxLayoutAlign="space-between center">
        <h2 class="m-0">Upload New Contract Template</h2>
      </div>
    </div>
    <ng-container *ngIf="contractForm">
      <div class="row mb-3 pt-3" [formGroup]="contractForm">
        <div class="col-sm-12  col-md-6 col-lg-2">
          <mat-select class="filterDropdown" placeholder="Select Product" formControlName="product">
            <ng-container *ngFor="let option of productOptions">
              <mat-option [value]="option.value">
                {{option.label}}
              </mat-option>
            </ng-container>
          </mat-select>
        </div>
        <div class="col-sm-12  col-md-6 col-lg-2">
          <mat-select class="filterDropdown" placeholder="Select State" formControlName="state">
            <ng-container *ngFor="let option of stateOptions">
              <mat-option [value]="option.value">
                {{option.label}}
              </mat-option>
            </ng-container>
          </mat-select>
        </div>
        <div class="col-sm-12  col-md-6 col-lg-2">
          <mat-select class="filterDropdown" placeholder="Select Market" formControlName="market">
            <ng-container *ngFor="let option of marketOptions">
              <mat-option [value]="option.value">
                {{option.label}}
              </mat-option>
            </ng-container>
          </mat-select>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-5" fxLayout="row">
          <app-file-attachments #attachments class="file" [fileLoading]="fileLoading" hideUploadButton="true" supportedFiles="docx" (fileDropped)="onFileDropped($event, 'file')"></app-file-attachments>
        </div>
        <button mat-flat-button color="primary" class="search-btn ml-2" [disabled]="contractForm.invalid" (click)="uploadTemplate()">Submit</button>
      </div>
    </ng-container>
  </div>
</div>

